import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFire } from '@fortawesome/free-solid-svg-icons';
import type { IconProp } from '@fortawesome/fontawesome-svg-core';
import { SectionCard } from '../../shared/SectionCard/SectionCard';
import { asHour } from '../../shared/utils/dashboard-page.utils';
import { SectionKey } from '../../shared/types/dashboard-page.types';
import { BumpTimesSummary } from '../../../../services/reports/reports.service';
import classes from './bump-times-section.module.scss';

export type BumpTimesSectionProps = {
  collapsedSections: Record<SectionKey, boolean>;
  toggleSection: (section: SectionKey) => void;
  bumpTimesSummary: BumpTimesSummary;
};

export const BumpTimesSection: React.FC<BumpTimesSectionProps> = ({
  collapsedSections,
  toggleSection,
  bumpTimesSummary,
}) => {
  if (!bumpTimesSummary.firstBumpAt && !bumpTimesSummary.lastBumpAt) {
    return (
      <SectionCard title="זמני בון" sectionKey="bumpTimes" collapsed={collapsedSections.bumpTimes} onToggle={() => toggleSection('bumpTimes')}>
        <p className={classes.emptyHint}>אין נתונים להצגה</p>
      </SectionCard>
    );
  }

  return (
    <SectionCard title="זמני בון" sectionKey="bumpTimes" collapsed={collapsedSections.bumpTimes} onToggle={() => toggleSection('bumpTimes')}>
      <div className={classes.grid}>
        <div className={classes.card}>
          <div className={classes.header}>
            <FontAwesomeIcon className={classes.icon} icon={faFire as IconProp} />
            <span>בון ראשון</span>
          </div>
          <div className={classes.value}>{bumpTimesSummary.firstBumpAt ? asHour(bumpTimesSummary.firstBumpAt) : '—'}</div>
        </div>
        <div className={classes.card}>
          <div className={classes.header}>
            <FontAwesomeIcon className={classes.icon} icon={faFire as IconProp} />
            <span>בון אחרון</span>
          </div>
          <div className={classes.value}>{bumpTimesSummary.lastBumpAt ? asHour(bumpTimesSummary.lastBumpAt) : '—'}</div>
        </div>
      </div>
    </SectionCard>
  );
};
